module.exports = require("share-my-url");


//////////////////
// WEBPACK FOOTER
// external "share-my-url"
// module id = 260
// module chunks = 0